const IMAGE_WIDTH_HASH_RE = /^#(?:.*&)?hv-width=(\d+)/;
const IMAGE_SIZE_HASH_RE = /^#(?:.*&)?hv-size=(\d+)x(\d+)/;

export interface HelpImageNaturalSize {
  readonly width: number;
  readonly height: number;
}

/** Splits the editor's `#hv-width=N&hv-size=WxH` hints off an image URL. */
export function helpImageSource(raw: string): {
  readonly src: string;
  readonly width: number | null;
  readonly natural: HelpImageNaturalSize | null;
} {
  const hashIndex = raw.indexOf("#");
  if (hashIndex < 0) return { src: raw, width: null, natural: null };
  const hash = raw.slice(hashIndex);
  const widthMatch = IMAGE_WIDTH_HASH_RE.exec(hash);
  const width = widthMatch?.[1] ? Number.parseInt(widthMatch[1], 10) : 0;
  const sizeMatch = IMAGE_SIZE_HASH_RE.exec(hash);
  const naturalWidth = sizeMatch?.[1] ? Number.parseInt(sizeMatch[1], 10) : 0;
  const naturalHeight = sizeMatch?.[2] ? Number.parseInt(sizeMatch[2], 10) : 0;
  return {
    src: raw.slice(0, hashIndex),
    width: width > 0 ? width : null,
    natural:
      naturalWidth > 0 && naturalHeight > 0
        ? { width: naturalWidth, height: naturalHeight }
        : null,
  };
}
